import { all, takeEvery, fork } from "redux-saga/effects";

import actions from "./actions";
// import { apis } from "../../properties.js";

// const getPostsURL = apis.get_posts_url;

export function* getPosts() {
  yield takeEvery(actions.GET_POSTS, function*() {
    try {
      yield console.log("Default Saga");
    } catch (error) {
      console.log(error);
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getPosts)]);
}
